export default {
  getCertificate: (axios, vin) => axios.get(`/api/digitalCertificates/${vin}`),
  createCerificate: (axios, data, dealerId) =>
    axios.post(`/api/digitalCertificates`, data, {
      headers: { 'X-DealerId': dealerId },
    }),
  updateCerificate: (axios, id, data) =>
    axios.put(`/api/digitalCertificates/${id}`, data),
  getCertificateData: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/complete`),
  setCertificateImage: (axios, data) =>
    axios.post(`/api/digitalCertificates/image`, data),
  updateCertificateImage: (axios, id, data) =>
    axios.put(`/api/digitalCertificates/${id}/image`, data),
  approveCertificate: (axios, id) =>
    axios.put(`/api/digitalCertificates/${id}/confirm`, null),
}
